import React from "react";
import About from "./About/About";
import Landing from "./Landing/Landing";
import Showcase from "./Showcase/Showcase";
import Features from "./Features/Features";

const Home = () => {
  return (
    <>
    <Landing/>
    <Features/>
    <Showcase/>
    <About/>
    </>
  );
}

export default Home;

